import React from 'react';
import { bool, func, node, number, oneOf, oneOfType, shape, string } from 'prop-types';
import styled from 'styled-components';

import Col from 'ravenjs/lib/Col';
import { callFunc, getHandler } from 'ravenjs/utils/actions';
import { responsiveProptypes } from 'ravenjs/utils/proptypes';
import ClearIcon from 'ravenjs/lib/SvgIcon/types/ClearIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const EllipsisStyled = styled.div`
    font-family: Roboto;
    font-size: 1rem;
    line-height: normal;
    overflow: hidden;
    padding: 0.875rem 0.875rem 0.875rem 1.5rem;
    width: 100%;
    word-break: break-word;
    text-overflow: unset;
    font-weight: 400;
    color: black;
`;

const BannerStyled = styled(Col)`
    background-color: ${({ color }) => color};
    display: flex;
    width: 80rem;
    height: auto;
    min-height: 87px;
    align-items: flex-start;
    border-top: solid 1px ${DEFAULT_COLORS.BLACK};
`;

const ClearIconStyled = styled(ClearIcon)`
    cursor: pointer;
    ${({ theme }) => theme.media.down('md')`
        margin: auto 0;
    `};
    ${({ theme }) => theme.media.up('md')`
        margin: auto 1.25rem;
        width: 22px;
        height: 22px;
    `};
`;

const IconWrapperStyled = styled.div`
    padding-top: 16px;
`;

function Banner(props) {
    const {
        color,
        dismissible,
        displayText,
        handlers,
        height,
        Icon,
        onlyText,
        size,
        fontWeight,
        ...rest
    } = props;
    const onDismissBanner = getHandler(handlers, 'onDismissBanner');

    return (
        displayText && (
            <BannerStyled color={color} height={height} size={size} {...rest}>
                <IconWrapperStyled>{Icon}</IconWrapperStyled>
                <EllipsisStyled>{displayText}</EllipsisStyled>
                {dismissible && (
                    <ClearIconStyled
                        fill={DEFAULT_COLORS.BLACK}
                        onClick={() => {
                            callFunc(onDismissBanner, rest);
                        }}
                    />
                )}
            </BannerStyled>
        )
    );
}

Banner.propTypes = {
    color: string,
    dismissible: bool,
    displayText: string,
    handlers: shape({
        onDismissBanner: func,
    }),
    height: string,
    Icon: oneOfType([node, func]),
    onlyText: bool,
    size: responsiveProptypes(oneOfType([oneOf(['auto', '*', false]), number, string])),
    fontWeight: string,
};

Banner.defaultProps = {
    color: DEFAULT_COLORS.ORANGE,
    dismissible: true,
    displayText: '',
    handlers: {},
    height: '87px',
    Icon: null,
    onlyText: false,
    size: '*',
    fontWeight: null,
};

export default Banner;
